import { colorsPalettes, mixins } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

export const StyledCardContainer = styled.div`
    border-radius: 10px;
    background: rgb(236, 241, 255);
    padding: 8px;
    width: 100%;
    box-sizing: border-box;
    box-shadow: 0px 3px 6px 0px rgba(14, 30, 62, 0.08);
`;

export const StyledCardHeaderWrapper = styled(FlexRow)`
    padding: 4px 8px;
    align-items: center;
`;

export const StyledCardHeaderTextWrapper = styled(FlexRow)`
    width: 100%;
    flex: 3;
    align-items: flex-start;
`;

export const StyledCardHeaderContent = styled(FlexColumn)`
    justify-content: center;
    align-self: center;
`;

export const StyledCardContent = styled.div`
    overflow: hidden;

    &:not(:first-of-type) {
        margin-top: 8px;
    }
`;

export const StyledCardIcon = styled.div`
    margin-right: 16px;
`;

export const StyledCardTitle = styled.h6`
    ${mixins.setFontVariant("h6", colorsPalettes.carbon["500"])};
    margin: 0;
`;
